import { EmployeesInfo } from '../data_types/empoyees-info';
import { ModalAttributes } from '../data_types/modal';

export const CONTACT_STATUS = {
    TERMINATED: 'Terminated',
    NON_MEMBER: 'Non-Member',
    ACTIVE: 'Active',
    LAPSED: 'Lapsed',
};

export const DEFAULT_MODAL_CONTENT: ModalAttributes = {
    isOpen: false,
    title: 'Error',
    content: 'An error occurred.',
    onConfirm: (): void => window.location.reload(),
    confirmActionName: 'Reload',
};

export const INVALID_SESSION_MODAL_CONTENT: ModalAttributes = {
    ...DEFAULT_MODAL_CONTENT,
    title: 'Session expired',
    content: 'Your session has expired and you need to log in again.',
};

export const SESSION_INVALID_ERROR = 'not authenticated';

export const SUPPLEMENTAL_DUES_OPTIONS_NON_SOLE_PRACTITIONER =
    'I am not a sole practitioner, and I do not own or manage an architecture firm.';
export const SUPPLEMENTAL_DUES_OPTIONS_DESIGNATE_MEMBER =
    'I own or manage an architecture firm and designate another AIA member to pay the supplemental dues my firm owes.';
export const SUPPLEMENTAL_DUES_OPTIONS_SOLE_PRACTITIONER = 'I am a sole practitioner.';
export const SUPPLEMENTAL_DUES_OPTIONS_MANAGE_FIRM = 'I own or manage an architectural firm.';

export const EMPLOYEES_INFO: EmployeesInfo = {
    memberArchitectCount: {
        count: 'AIA_Member_Architect_Count__c',
        rate: 'AIA_Architect_Member_Rate__c',
        label: 'Architect Member',
    },
    nonMemberArchitectCount: {
        count: 'AIA_Non_member_Architect_Count__c',
        rate: 'AIA_Architect_Non_Member_Rate__c',
        label: 'Architect Non-Member',
    },
    associateCount: {
        count: 'AIA_Associate_Count__c',
        rate: 'AIA_Associate_Rate__c',
        label: 'Associate',
    },
    technicalStaffCount: {
        count: 'AIA_Technical_Staff_Count__c',
        rate: 'AIA_Tech_Staff_Rate__c',
        label: 'Technical Staff',
    },
    otherStaffCount: {
        count: 'AIA_Other_Staff_Count__c',
        rate: 'AIA_Other_Staff_Rate__c',
        label: 'Other Staff',
    },
};

export const ARCHIPAC_DONATION_NAME_EXPRESSION = 'ArchiPAC';
export const ARCHIPAC_DONATION_DISCLAIMER = `Contributions to ArchiPAC are not tax-deductible and are strictly voluntary. They support political purposes and are subject to federal law. You may refuse to contribute without reprisal. Contribution guidelines are suggestions only; you may contribute more or less, and will not be favored or disadvantaged based on your contribution amount or a decision not to contribute. To contribute more or less than $25.00, please visit archipac.org. Only U.S. citizens and lawful permanent residents may contribute, and personal funds must be used. Corporate and federal contractor contributions are prohibited. Federal law requires us to use best efforts to collect and report the name, address, employer, and occupation of individuals whose contributions are over $200 for the calendar year. If a contribution cannot be used for PAC purposes, we will notify the donor and transfer it to the Architects Advocacy Fund (AAF), a non-PAC fund supporting advocacy. Refunds may be requested at that time.`;

export const ARCHIPAC_DONATION_NOTE = `ArchiPAC is prohibited from accepting business funds or contributions by company credit card or business checking account.`;

export const ORLANDO_FOUNDATION_FOR_ARCHITECTURE_DISCLAIMER =
    'I would like to make a voluntary, tax-deductible contribution to The Orlando Foundation for Architecture (OFA), a 501(c)(3) non-profit organization dedicated to public education that inspires people to discover WHY DESIGN MATTERS. No goods or services were provided in exchange for this contribution. Because OFA does not engage in political activities, contributions are 100% deductible.';
export const SAN_FRANCISCO_SPECIAL_ASSESSMENT_DISCLAIMER =
    `This contribution will be recognized as a donation and may qualify as a deductible trade or business expense.  As an Architect member, you’ll receive Center for Architecture + Design benefits with your AIA San Francisco membership. Learn more at https://www.aiasf.org/centersf-benefits.`;
export const TAMPA_BAY_CENTER_FOR_ARCHITECTURE_DISCLAIMER =
    'I would like to make a voluntary, contribution to the Center for Architecture & Design, Tampa Bay. No goods or services were provided in exchange for this contribution. Because the 501(c)(3) status for the Center for Architecture & Design, Tampa Bay is pending, this contribution is not tax deductible.';

export const PARTIAL_AIAU_SUBSCRIPTION_OPTIONAL_ITEM_NAME = 'AIAU Subscription';
export const INSTALLMENT_ADMINISTRATION_FEE_NAME = 'Installment';

export const MEMBERSHIP_TYPE_ARCHITECT = process.env.REACT_APP_MEMBERSHIP_TYPE_ARCHITECT || 'Architect';
export const MEMBERSHIP_TYPE_INTL_ASSOCIATE = process.env.REACT_APP_MEMBERSHIP_TYPE_INTL_ASSOCIATE || 'Intl Associate';
export const MEMBERSHIP_TYPE_ASSOCIATE = process.env.REACT_APP_MEMBERSHIP_TYPE_ASSOCIATE || 'Associate';
export const MEMBERSHIP_TYPE_HONORARY = process.env.REACT_APP_MEMBERSHIP_TYPE_HONORARY || 'Honorary';
export const MEMBERSHIP_TYPE_ALLIED = process.env.REACT_APP_MEMBERSHIP_TYPE_ALLIED || 'Allied';

export const SELF_DESCRIBE_US_ARCHITECT = 'us-license-architect';
export const SELF_DESCRIBE_NON_US_ARCHITECT = 'non-us-license-int-associate';
export const SELF_DESCRIBE_NEW_GRADUATE = 'new-graduate-associate';
export const SELF_DESCRIBE_AXP_ENROLLED = 'axp-enrolled-associate';
export const SELF_DESCRIBE_ARCHITECT_DEGREE = 'architect-degree-associate';
export const SELF_DESCRIBE_SUPERVISION = 'licensed-supervision-associate';
export const SELF_DESCRIBE_FACULTY_MEMBER = 'faculty-member-associate';
export const SELF_DESCRIBE_ALLIED = 'professional-allied';

export const JOIN_SELF_DESCRIBE_OPTIONS: { label: string; value: string }[] = [
    {
        label: 'I hold an active architecture license from a U.S. licensing authority.',
        value: SELF_DESCRIBE_US_ARCHITECT,
    },
    {
        label: 'I hold an active architecture license from a non-U.S. licensing authority.',
        value: SELF_DESCRIBE_NON_US_ARCHITECT,
    },
    {
        label: 'I am a new graduate.',
        value: SELF_DESCRIBE_NEW_GRADUATE,
    },
    {
        label: 'I am enrolled in AXP.',
        value: SELF_DESCRIBE_AXP_ENROLLED,
    },
    {
        label: 'I am not licensed, but I have an architecture degree.',
        value: SELF_DESCRIBE_ARCHITECT_DEGREE,
    },
    {
        label: 'I do not have an architecture degree, but I am working under the supervision of a licensed architect.',
        value: SELF_DESCRIBE_SUPERVISION,
    },
    {
        label: 'I am a faculty member in an architecture program.',
        value: SELF_DESCRIBE_FACULTY_MEMBER,
    },
    {
        label: 'I am an allied professional.',
        value: SELF_DESCRIBE_ALLIED,
    },
];

export const MEMBERSHIP_TYPE_MAPPING: { [key: string]: string | undefined } = {
    [SELF_DESCRIBE_US_ARCHITECT]: MEMBERSHIP_TYPE_ARCHITECT,
    [SELF_DESCRIBE_NON_US_ARCHITECT]: MEMBERSHIP_TYPE_INTL_ASSOCIATE,
    [SELF_DESCRIBE_NEW_GRADUATE]: MEMBERSHIP_TYPE_ASSOCIATE,
    [SELF_DESCRIBE_AXP_ENROLLED]: MEMBERSHIP_TYPE_ASSOCIATE,
    [SELF_DESCRIBE_ARCHITECT_DEGREE]: MEMBERSHIP_TYPE_ASSOCIATE,
    [SELF_DESCRIBE_SUPERVISION]: MEMBERSHIP_TYPE_ASSOCIATE,
    [SELF_DESCRIBE_FACULTY_MEMBER]: MEMBERSHIP_TYPE_ASSOCIATE,
    [SELF_DESCRIBE_ALLIED]: MEMBERSHIP_TYPE_ALLIED,
};

export const MEMBERSHIP_COUNTRY_UNITED_STATES = 'United States';

export const DUES_ESTIMATOR_DISCLAIMER = `Disclaimer: The dues calculator is a tool to estimate new or former prospective membership
dues for national, state and local chapter assignment before the join process. In some cases,
the dues amounts may be different based on the estimated amounts provided before joining.
Changes in total cost may depend on membership categories, prior membership with the AIA or
local or state chapter assignment. If you need the actual membership dues amount, please start
the online join process or contact AIA member services at (800) 242-3837, option 2 or 1+ (202)
626-7300, option 2 (outside the U.S.).`;

export const LOCAL_STORAGE_DUES_ESTIMATOR_VALUES_KEY = 'dues-estimator-default-values';
export const CES_AUDIT_FAILED = 'Audited-Failed';
export const UNDER_CES_AUDIT = 'Under Audit';
